module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('em', [_vm._v("Abbreviations")])])]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BAR")])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Archaeology Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BBR")])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin for Biblical Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BSac")])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bibliotheca Sacra")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CBQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CovQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Covenant Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CTJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Calvin Theological Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EvQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Evangelical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JBL")])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JETS")])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the Evangelical Theological Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NIB")])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The New Interpreter’s Bible")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NIBC")])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New International Bible Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NICOT")])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New International Commentary on the Old Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NIDOTTE")])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("New International Dictionary of Old Testament Theology and Exegesis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TDOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theological Dictionary of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TynBul")])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Tyndale Bulletin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("VT")])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Vetus Testamentum")])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abb1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("WW")])])]), _vm._v(" "), _c('td', {
    staticClass: "abb2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Word and World")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ef5ba79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Abbreviations.vue
// module id = 78
// module chunks = 0